module.exports = __webpack_public_path__ + "assets/images/lamp_esmerald.svg?1a25341ca0cbbc1ca24141688fc02948";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/lamp_esmerald.svg
// module id = 612
// module chunks = 0